import { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

import Message from '../Message/Message';

// import { getUserAccount } from 'store/user-actions';
import { saveMetadataAcademy } from 'store/academy-actions';

import classes from './MetadataModal.module.css';

const MetadataModal = props => {
  const [emailError, setEmailError] = useState(false);
  const [openMessage, setOpenMessage] = useState(false);
  const [campus, setCampus] = useState(
    props.metadata[0] && props.metadata[0].preloadData
      ? `${props.metadata[0].preloadData}`
      : ''
  );
  const [email, setEmail] = useState(
    props.metadata[1] && props.metadata[1].preloadData
      ? `${props.metadata[1].preloadData}`
      : ''
  );
  const [sendData, setSendData] = useState(false);

  const handleChange = param => event => {
    if (param === 'email') {
      setEmail(event.target.value);
      setEmailError(false);
    }
  };

  const handleChangeCampus = event => {
    setCampus(event.target.value);
  };

  const validateEmailDomain = email => {
    return email.endsWith('@my.uvm.edu.mx');
  };

  const handleCloseMessage = () => {
    setOpenMessage(false);
  };

  const saveMetadata = async () => {
    setSendData(true);
    let checkEmail = null;
    if (props.metadata[1] && props.metadata[1].tag === 'emailuvm') {
      if (email) {
        checkEmail = validateEmailDomain(email);
        if (!checkEmail) {
          setSendData(false);
          alert('El correo debe ser de la UVM');
          return;
        } else {
          // const emailExists = await checkUserHandler(email);
          // if (emailExists) {
          //   setSendData(false);
          //   return;
          // }
        }
      }
    }

    const getValueByDescription = description => {
      switch (description) {
        case 'Indica tu campus':
          return campus;
        case 'Correo Electrónico Institucional':
          return email;
        default:
          return '';
      }
    };

    const data = props.metadata.map(item => ({
      tag: item.tag,
      tagValue: getValueByDescription(item.description)
    }));

    (async () => {
      const saveData = await saveMetadataAcademy(data);
      if (saveData) {
        props.handleClose();
      } else {
        // setOpenMessage(true);
        setEmailError(true);
        setSendData(false);
      }
    })();
  };

  return (
    <>
      <Dialog open={props.open}>
        {props.metadata && (
          <>
            <DialogTitle>
              Actualización de información adicional
            </DialogTitle>
            <DialogContent>
              <DialogContentText className={classes.infoContainer}>
                Una vez que hayas actualizado tus datos, presiona el
                botón "Guardar Cambios" para acceder normalmente al
                contenido.
              </DialogContentText>
              {props.metadata.map(item =>
                item.optionsList.length >= 2 ? (
                  <FormControl fullWidth key={item.name}>
                    <InputLabel id="campusSelect">
                      {item.name}
                    </InputLabel>
                    <Select
                      labelId="campusSelect"
                      value={campus}
                      label={item.name}
                      onChange={handleChangeCampus}
                    >
                      {item.optionsList.map(option => (
                        <MenuItem key={option.trim()} value={option}>
                          {option.trim()}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) : item.tag === 'emailuvm' ? (
                  <>
                    <FormControl fullWidth key={item.name}>
                      <TextField
                        label={item.name}
                        value={email}
                        onChange={handleChange('email')}
                        margin="normal"
                        variant="outlined"
                        className={classes.inputField}
                        onInput={e => {
                          let email = e.target.value.replace(
                            /\s+/g,
                            ''
                          );
                          email = email
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '');
                          e.target.value = email;
                        }}
                      />
                    </FormControl>
                    {emailError && (
                      <div className={classes.warningTextContainer}>
                        <p className={classes.warningTextTitle}>
                          ¡Este correo ya está registrado!
                        </p>
                        <p className={classes.warningTextSubitle}>
                          Por favor ingresa un correo diferente o, si
                          necesitas ayuda, contacta a nuestro{' '}
                          <a
                            href="http://ayuda.mayahii.com/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Centro de ayuda
                          </a>
                          .
                        </p>
                      </div>
                    )}
                  </>
                ) : (
                  ''
                )
              )}
            </DialogContent>
            <div className={classes.btnsContainer}>
              <Button
                onClick={props.handleClose}
                className={classes.closeBtn}
              >
                Agregar información más tarde
              </Button>
              <Button
                onClick={saveMetadata}
                className={classes.saveBtn}
                disabled={!campus || sendData}
              >
                Guardar Cambios
              </Button>
            </div>
          </>
        )}
      </Dialog>
      {openMessage && (
        <Message
          openDialog={openMessage}
          closeDialog={handleCloseMessage}
          message="Error al guardar los datos. Por favor, inténtalo nuevamente."
          btnText="Aceptar"
        />
      )}
    </>
  );
};

MetadataModal.propTypes = {
  // eslint-disable-next-line react/require-default-props
  handleClose: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  open: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  metadata: PropTypes.array
};

export default MetadataModal;
